import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.049 2.927C11.349 2.006 12.652 2.006 12.951 2.927L14.47 7.601C14.5354 7.80149 14.6625 7.97618 14.8331 8.10011C15.0037 8.22403 15.2091 8.29085 15.42 8.291H20.335C21.304 8.291 21.706 9.531 20.923 10.101L16.947 12.989C16.7762 13.1132 16.6491 13.2882 16.5839 13.489C16.5187 13.6899 16.5187 13.9062 16.584 14.107L18.102 18.781C18.402 19.703 17.347 20.469 16.564 19.899L12.588 17.011C12.4171 16.8868 12.2113 16.8199 12 16.8199C11.7887 16.8199 11.5829 16.8868 11.412 17.011L7.436 19.899C6.653 20.469 5.598 19.702 5.898 18.781L7.416 14.107C7.48128 13.9062 7.48132 13.6899 7.41611 13.489C7.3509 13.2882 7.2238 13.1132 7.053 12.989L3.077 10.101C2.293 9.531 2.697 8.291 3.665 8.291H8.579C8.79005 8.29106 8.99571 8.22434 9.16653 8.1004C9.33735 7.97646 9.46458 7.80165 9.53 7.601L11.049 2.927Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }